// Thư viện khối TikTok cho Tự dựng — selector data-e2e ĐÃ KIỂM THẬT (2026-09-20/21, cùng bộ với tools/tt-bundles.mjs; đổi ở đây
// thì đổi cả bên đó). Khối là dữ liệu thuần (xem shared/tu-dung.ts): AI chỉ điền tham số, không sờ vào selector.
import type { KhoiMau } from "./tu-dung";
import { DK_THICH_LUOT as TT_DK_THICH_LUOT } from "./ti-le-thich";
import { themChiBaiLienQuan } from "./chi-lien-quan"; // (05/10) "Chỉ bình luận bài liên quan" co/khong cho mọi khối có bước chấm

export const TT_URL = "https://www.tiktok.com/";
const EDITOR = '[data-e2e="comment-text"] [contenteditable="true"]';
const EDITOR_ALT = 'div[role="textbox"][contenteditable="true"]';

export const VIDEO_LIST_SPEC = {
  mode: "list",
  list: { describe: "danh sách video kết quả tìm kiếm", ladder: [{ t: "css", sel: 'div[data-e2e="search_video-item-list"] > div' }] },
  fields: {
    tac_gia: { sel: '[data-e2e="search-card-user-unique-id"]', attr: "text", alt: ['a[data-e2e="search-card-user-link"]'] },
    mo_ta: { sel: '[data-e2e="search-card-video-caption"]', attr: "text", alt: ['[data-e2e="search-card-desc"]'], fallback: "longest_text" },
    luot_xem: { sel: '[data-e2e="video-views"]', attr: "text" },
    lien_ket: { sel: 'a[href*="/video/"]', attr: "href" },
    anh_url: { sel: null, attr: "anh_lon" }, // ảnh bìa video — AI nhìn khi mô tả quá ngắn
  },
  item_key: "lien_ket",
};

// CHỐT ĐÚNG VIDEO trước khi gõ và trước phím Enter (Action.chot — content script kiểm cùng lượt với thao tác): trang video TikTok là feed dọc, hết
// video thì TỰ CHUYỂN sang video kế (kiểm thật 2026-09-21: URL đổi, SPA) — trong lúc mở bảng bình luận → gõ → Enter mà trang đã sang video khác thì
// Enter là bình luận vào VIDEO KHÁC, hậu kiểm "thấy chữ" vẫn đạt (E2E binh-luan-tu-chuyen BT1/BT2 đỏ trên bản cũ). So theo MÃ video (ma_video).
// Hậu kiểm cũng chốt url chứa mã video: chữ hiện dưới video khác không tính là đạt.
const CHOT_VIDEO = (bienUrl: string) => ({ cond: { t: "url_contains", s: `{{ ma_video(${bienUrl}) }}` }, ly_do: "trang đã tự chuyển sang video khác — không gửi (tránh đăng nhầm vào video khác)" });
const DA_GUI = (bienUrl: string, chu: string) => [{ t: "url_contains", s: `{{ ma_video(${bienUrl}) }}` }, { t: "text_visible", text: chu }];

// Mở video → bấm nút bình luận (bảng đóng sẵn; trang có thể xếp 2 video dọc → lấy nút [1]) → gõ + Enter (Draft.js nhận textInput).
const DANG_ACTIONS = [
  { kind: "navigate", url: "{{item.lien_ket}}" },
  { kind: "click", target: { describe: "nút Bình luận của video đang xem", ladder: [
    { t: "xpath", xpath: '(//*[@data-e2e="comment-icon"])[1]' },
    { t: "css", sel: '[data-e2e="comment-icon"]' },
    { t: "css", sel: '[data-e2e="comment-text"]' },
    { t: "model", prompt: "nút mở bảng bình luận (biểu tượng bong bóng chat) của video đang xem" },
  ] } },
  { kind: "type", target: { describe: "ô Add comment", ladder: [
    { t: "css", sel: EDITOR },
    { t: "css", sel: EDITOR_ALT },
    { t: "model", prompt: "ô Add comment — ô nhập bình luận (contenteditable) ở bảng bình luận của video" },
  ] }, text: "{{item.binh_luan}}", enter: true, chot: CHOT_VIDEO("item.lien_ket") },
];

// Bình luận trên trang video (kiểm thật 2026-09-21 13:50): mỗi bình luận cấp 1 = div[class*=DivCommentItemWrapper] là CON TRỰC TIẾP của
// div[class*=DivCommentObjectWrapper] (trả lời cấp 2 nằm ở khối khác nên không lẫn); trong đó: [data-e2e=comment-username-1] tên,
// [data-e2e=comment-level-1] nội dung, [data-e2e=comment-like-count] số thích, [data-e2e=comment-reply-1] nút Reply → bấm thì ô nhập
// chung đổi placeholder "Add a reply..." và được focus → gõ + Enter như bình luận thường.
const COMMENT_LIST_SPEC = {
  mode: "list",
  list: { describe: "danh sách bình luận cấp 1 của video", ladder: [{ t: "css", sel: 'div[class*="DivCommentObjectWrapper"] > div[class*="DivCommentItemWrapper"]' }, { t: "css", sel: 'div[class*="DivCommentItemWrapper"]' }] },
  fields: {
    nguoi: { sel: '[data-e2e="comment-username-1"]', attr: "text" },
    noi_dung: { sel: '[data-e2e="comment-level-1"]', attr: "text", fallback: "longest_text" },
    thich: { sel: '[data-e2e="comment-like-count"]', attr: "text" },
    anh_url: { sel: null, attr: "anh_lon" }, // ảnh kèm bình luận (nếu có) — AI nhìn khi chữ ngắn ("cái này sao vậy?" + ảnh)
  },
  item_key: "noi_dung",
};

export const MO_BINH_LUAN_ACTIONS = (url: string) => [
  { kind: "navigate", url },
  { kind: "click", target: { describe: "nút Bình luận của video đang xem", ladder: [
    { t: "xpath", xpath: '(//*[@data-e2e="comment-icon"])[1]' },
    { t: "css", sel: '[data-e2e="comment-icon"]' },
    { t: "css", sel: '[data-e2e="comment-text"]' },
    { t: "model", prompt: "nút mở bảng bình luận (biểu tượng bong bóng chat) của video đang xem" },
  ] } },
];

// CHẾ ĐỘ TRẢ LỜI (lỗi thật 2026-10-02: bấm Reply không ăn → ô nhập vẫn "Add comment..." → gõ + Enter = câu thành BÌNH LUẬN CẤP 1, hậu kiểm "thấy
// chữ" vẫn đạt). Ô gõ trả lời CHỈ được nhận khi trang đang ở chế độ trả lời — KHÔNG có nấc "ô nhập bình luận chung" (EDITOR/EDITOR_ALT) hay nấc AI:
//   1. ô Draft.js có placeholder trả lời ("Add a reply…" — đo thật 2026-09-21; "Reply…"/"Trả lời…"/"Phản hồi…" dự phòng);
//   2. ô nằm gần nhãn "Replying to @…"/"Reply to @…"/"Đang trả lời…"/"Đang phản hồi…" (CHƯA ĐO THẬT — dự phòng cho giao diện mới);
//   3. ô nằm TRONG khối của chính bình luận cha (ô trả lời tại chỗ dưới bình luận — CHƯA ĐO THẬT).
// Không nấc nào khớp → runner bấm lại Reply MỘT lần (cú bấm rơi vào khoảng không), vẫn không → bước thất bại, KHÔNG gõ, KHÔNG Enter; trong vòng
// tra_loi_binh_luan (on_item_error: skip) thì bỏ mục đó với lý do. Ô placeholder chỉ hiện khi ô RỖNG → kiểm trước khi gõ là đúng lúc.
// Hai dấu hiệu 2-3 chưa đo được DOM thật (2026-10-03: Edge của bot tắt) — đo khi có dịp: bấm Reply trên TikTok thật rồi đọc DOM quanh ô nhập.
const PH_TRA_LOI = 'starts-with(normalize-space(.),"Add a reply") or starts-with(normalize-space(.),"Reply") or starts-with(normalize-space(.),"Trả lời") or starts-with(normalize-space(.),"Phản hồi")';
const NHAN_DANG_TRA_LOI = 'starts-with(normalize-space(text()),"Replying to") or starts-with(normalize-space(text()),"Reply to") or starts-with(normalize-space(text()),"Đang trả lời") or starts-with(normalize-space(text()),"Đang phản hồi")';
const O_TRA_LOI_NAC = (khoiCha: string) => [
  { t: "xpath", xpath: `(//div[contains(@class,"DraftEditor-root")][.//*[contains(@class,"public-DraftEditorPlaceholder-inner")][${PH_TRA_LOI}]]//*[@contenteditable="true"])[1]` },
  { t: "xpath", xpath: `(//*[@contenteditable="true"][ancestor::*[position()<=5][.//*[not(@contenteditable)][${NHAN_DANG_TRA_LOI}]]])[1]` },
  { t: "xpath", xpath: `(${khoiCha}//*[@contenteditable="true"])[1]` },
];
const MO_TA_O_TRA_LOI = "ô nhập ĐANG Ở CHẾ ĐỘ TRẢ LỜI bình luận đó (placeholder 'Add a reply…' / nhãn 'Replying to @…' / ô dưới bình luận cha) — chưa vào chế độ trả lời thì KHÔNG gõ, không gửi (tránh câu thành bình luận cấp 1)";
// Khối (DivCommentObjectWrapper) của bình luận cấp 1 — trả lời của nó nằm trong khối này (DivReplyContainer, đo thật 2026-09-21).
// Một bình luận cho sẵn (tra_loi_mot_binh_luan): tìm theo CHỮ. Trong vòng (tra_loi_binh_luan): theo VỊ TRÍ của mục (_index — danh sách lấy đúng
// các khối có DivCommentItemWrapper con trực tiếp), không phụ thuộc trường chữ của mục.
const KHOI_BL_CHA = (bienChu: string) => `//div[contains(@class,"DivCommentObjectWrapper")][.//*[@data-e2e="comment-level-1"][contains(normalize-space(.), {{ xpath_chu(${bienChu}) }})]]`;
const KHOI_BL_MUC = `(//div[contains(@class,"DivCommentObjectWrapper")][div[contains(@class,"DivCommentItemWrapper")]])[{{ item._index + 1 }}]`;
// Hậu kiểm: câu trả lời hiện TRONG khối của ĐÚNG bình luận cha (không tính ô nhập, không tính chữ của chính bình luận cha) — câu rơi thành
// bình luận cấp 1 hay sang bình luận khác thì KHÔNG đạt.
const DUOI_DUNG_CHA = (khoiCha: string, bienCau: string) => ({ t: "locator_visible", target: { describe: "câu trả lời nằm dưới đúng bình luận cha", ladder: [
  { t: "xpath", xpath: `(${khoiCha}[.//*[not(ancestor-or-self::*[@contenteditable="true"])][not(ancestor-or-self::*[@data-e2e="comment-level-1"])][contains(normalize-space(.), {{ xpath_chu(${bienCau}) }})]])[1]` },
] } });

const TRA_LOI_ACTIONS = [
  { kind: "click", target: { describe: "nút Reply của bình luận này", within: "item", ladder: [
    { t: "css", sel: '[data-e2e="comment-reply-1"]' },
    { t: "model", prompt: "nút Reply (trả lời) của bình luận đang xét" },
  ] } },
  { kind: "type", target: { describe: MO_TA_O_TRA_LOI, ladder: O_TRA_LOI_NAC(KHOI_BL_MUC) }, text: "{{item.tra_loi}}", enter: true, chot: CHOT_VIDEO("video_url") },
];

// Hội đồng trên TikTok: một bình luận = DivCommentItemWrapper có [data-e2e=comment-level-1] chứa chữ (kiểm thật 2026-09-21).
// KHÔNG có khối "thích bình luận": bản đồ dò thật không có nhãn nào cho nút tim của TỪNG bình luận (chỉ có tim của video) —
// không đoán selector cho thao tác bật/tắt. Cần dò thêm trước khi làm.
const TT_BL = '//div[contains(@class,"DivCommentItemWrapper")][.//*[@data-e2e="comment-level-1"][contains(normalize-space(.), {{ xpath_chu(chu_binh_luan) }})]]';
const TT_TRA_LOI_MOT_ACTIONS = [
  ...MO_BINH_LUAN_ACTIONS("{{bai_url}}"),
  { kind: "click", target: { describe: "nút Reply của bình luận chứa chữ đã cho", ladder: [
    { t: "xpath", xpath: `(${TT_BL}//*[@data-e2e="comment-reply-1"])[1]` },
    { t: "model", prompt: "nút Reply của bình luận chứa chữ {{chu_binh_luan}}" },
  ] } },
  { kind: "type", target: { describe: MO_TA_O_TRA_LOI, ladder: O_TRA_LOI_NAC(KHOI_BL_CHA("chu_binh_luan")) }, text: "{{cau_tra_loi}}", enter: true, chot: CHOT_VIDEO("bai_url") },
];
const TT_BINH_LUAN_MOT_ACTIONS = [
  ...MO_BINH_LUAN_ACTIONS("{{bai_url}}"),
  { kind: "type", target: { describe: "ô Add comment", ladder: [
    { t: "css", sel: EDITOR },
    { t: "css", sel: EDITOR_ALT },
    { t: "model", prompt: "ô Add comment — ô nhập bình luận ở bảng bình luận của video" },
  ] }, text: "{{binh_luan}}", enter: true, chot: CHOT_VIDEO("bai_url") },
];

// ===================== TikTok — THAO TÁC NHƯ NGƯỜI (2026-10-01): xem, thích, lướt =====================
// Đo thật Edge #2 (2026-10-01, CHỈ đọc DOM): trang video /@u/video/<id> và trang Dành cho bạn /foryou dùng CÙNG khung
// article[data-e2e="recommend-list-item-container"] (trang video: đúng 1 article; For You: nhiều) có <video> đang phát; nút tim =
// div[role=button][data-e2e="like-icon"] mang aria-pressed ("true" = ĐÃ thích — bấm nữa là BỎ thích; gặp thật: video đã thích sẵn có
// aria-pressed="true") → chỉ nhắm aria-pressed="false", không nấc "model". For You có nút [data-e2e="feed-navigation-next"] sang video kế.
// Trang KẾT QUẢ TÌM hôm đó bị CAPTCHA (đúng như Bot 333) — không bấm, không đọc tiếp; danh sách kết quả vẫn dùng VIDEO_LIST_SPEC đã kiểm 09-20/09-23.
// Trang video tự chuyển sang video kế khi hết (kiểm thật 2026-09-21) → bước Thích MỞ LẠI đúng video trước khi bấm (ảnh duyệt cũng đúng video).
const TT_THICH = { kind: "click", target: { describe: "nút Thích (tim) của video đang xem — chỉ khi CHƯA thích", ladder: [
  { t: "xpath", xpath: '(//*[@data-e2e="like-icon"][@aria-pressed="false"])[1]' },
] } };
const TT_DA_THICH = [{ t: "dom_exists", sel: '[data-e2e="like-icon"][aria-pressed="true"]' }];
// Trang mở ra phải có <video> (bố cục 2026-10-01: trong recommend-list-item-container; bố cục 09-23 khác khung) — không có = video lỗi/bị gỡ/captcha.
const TT_CO_VIDEO = { t: "dom_exists", sel: "video" };
// Tỉ lệ thích khi lướt: mỗi video được thích với XÁC SUẤT = tỉ lệ (biểu thức dùng chung, giữ nguyên chữ — src/shared/ti-le-thich.ts).
const TT_TS_TI_LE_THICH = { ten: "ti_le_thich", moTa: "phần trăm video được bấm Thích khi lướt (0-30; 0 = chỉ xem, không thích)", kieu: "so" as const, min: 0, max: 30, macDinh: "10" };
const TT_TS_GIAY_XEM = { ten: "giay_xem", moTa: "số giây xem mỗi video trước khi làm việc khác (3-300)", kieu: "so" as const, min: 3, max: 300, macDinh: "20" };

// ===================== TikTok — TRẢ LỜI BÌNH LUẬN DƯỚI VIDEO CỦA CHÍNH MÌNH (tư cách chủ kênh, 2026-10-03) =====================
// Luồng: đọc nick đang đăng nhập (liên kết Hồ sơ ở thanh bên, /@<nick>) → mở trang cá nhân /@<nick> → video MỚI NHẤT (bỏ video ghim) → mở bảng
// bình luận (như tra_loi_binh_luan) → đọc bình luận cấp 1 → chỉ trả lời bình luận của NGƯỜI KHÁC chưa được mình phản hồi, chưa có trong sổ cái →
// AI soạn như chủ kênh → bấm Reply, gõ vào ô ĐANG Ở CHẾ ĐỘ TRẢ LỜI, Enter; hậu kiểm câu nằm dưới ĐÚNG bình luận cha (DUOI_DUNG_CHA, e7c4d59).
// Tổng số câu mỗi lượt (so_cau) chung mọi video: biến đếm dem_cau_tt (như YouTube).
// ĐÃ ĐO THẬT (dùng lại): nút comment-icon, DivCommentObjectWrapper > DivCommentItemWrapper, comment-username-1 / comment-level-1 / comment-reply-1,
// ô Draft.js "Add a reply…" (2026-09-21).
// Khảo sát thật 04/10: liên kết Hồ sơ a[data-e2e="nav-profile"] href "/@nick" ĐÃ ĐO (de_xuat #26, hop_thu #19, tim_nguoi #20). Phần còn lại các trang
// khảo sát TikTok bị CAPTCHA nên VẪN GIẢ ĐỊNH:
// lưới video trang cá nhân [data-e2e="user-post-item-list"] > div
// / [data-e2e="user-post-item"], nhãn ghim [data-e2e="video-card-badge"] ("Pinned"/"Đã ghim"); liên kết tác giả bình luận a[href*="/@"]; khu phản hồi
// DivReplyContainer có liên kết về /@nick của mình hoặc nhãn "Creator"/"Tác giả" = mình đã phản hồi (phản hồi đang THU GỌN thì không thấy — sổ cái vẫn
// chặn câu do máy đã gửi).
export const TT_NICK_SPEC = { mode: "single", target: { describe: "liên kết Hồ sơ của nick TikTok đang đăng nhập (thanh bên, /@nick) — không có = chưa đăng nhập / trang đăng nhập / CAPTCHA → dừng", ladder: [
  { t: "xpath", xpath: '(//a[@data-e2e="nav-profile"][contains(@href, "/@")])[1]' },
  { t: "xpath", xpath: '(//*[@data-e2e="profile-icon"]/ancestor-or-self::a[contains(@href, "/@")])[1]' },
] }, attr: "href", regex: "/@([A-Za-z0-9._]+)" };
export const TT_VIDEO_CA_NHAN_SPEC = {
  mode: "list",
  list: { describe: "video trên trang cá nhân của mình (mới nhất trước, có thể có video ghim ở đầu)", ladder: [
    { t: "css", sel: '[data-e2e="user-post-item-list"] > div' },
    { t: "css", sel: '[data-e2e="user-post-item"]' },
  ] },
  fields: {
    lien_ket: { sel: 'a[href*="/video/"]', attr: "href" },
    ghim: { sel: '[data-e2e="video-card-badge"]', attr: "text", phan_loai: [{ re: "Pinned|Đã ghim|Ghim|ghim", gt: "co" }] },
    luot_xem: { sel: '[data-e2e="video-views"]', attr: "text" },
  },
  item_key: "lien_ket",
};
const TT_BL_KENH_SPEC = {
  mode: "list",
  list: { describe: "bình luận cấp 1 dưới video của mình (cả khối, gồm khu phản hồi)", ladder: [
    { t: "css", sel: 'div[class*="DivCommentObjectWrapper"]:has(> div[class*="DivCommentItemWrapper"])' },
    { t: "css", sel: 'div[class*="DivCommentObjectWrapper"]' },
  ] },
  fields: {
    nguoi: { sel: '[data-e2e="comment-username-1"]', attr: "text" },
    nguoi_id: { sel: 'div[class*="DivCommentItemWrapper"] a[href*="/@"]', attr: "href", regex: "/@([^/?#]+)", alt: ['a[href*="/@"]'] },
    noi_dung: { sel: '[data-e2e="comment-level-1"]', attr: "text" },
    kenh_tl_lien_ket: { sel: 'div[class*="DivReplyContainer"] a[href$="/@{{nick_tt}}" i], div[class*="DivReplyContainer"] a[href*="/@{{nick_tt}}?" i]', attr: "href" },
    kenh_tl_nhan: { sel: 'div[class*="DivReplyContainer"]', attr: "text", phan_loai: [{ re: "\\bCreator\\b|Tác giả|Người sáng tạo", gt: "co" }] },
    anh_url: { sel: null, attr: "anh_lon" },
  },
  item_key: "noi_dung",
};
const TT_TRA_LOI_KENH_ACTIONS = [
  { kind: "click", target: { describe: "nút Reply của bình luận này", within: "item", ladder: [{ t: "css", sel: '[data-e2e="comment-reply-1"]' }] } },
  { kind: "type", target: { describe: MO_TA_O_TRA_LOI, ladder: O_TRA_LOI_NAC(KHOI_BL_MUC) }, text: "{{item.tra_loi}}", enter: true, chot: CHOT_VIDEO("video_tt_url") },
];

// ===================== ĐỂ TRỐNG ĐỊA CHỈ VIDEO → TỰ TÌM VIDEO (05/10/2026, src/shared/tu-dung.ts BienTheTuTim) =====================
// Như YouTube (yt-khoi.ts): tìm video theo từ khoá của kịch bản (máy điền lúc lắp), đọc nick đang đăng nhập (liên kết Hồ sơ /@nick ở thanh bên — ĐÃ ĐO
// 04/10; không đọc được thì không lọc theo nick), bỏ video của CHÍNH nick, video đã làm (sổ cái), [AI chấm liên quan], làm ĐÚNG MỘT video. Xem → thích →
// bình luận cùng để trống dùng CHUNG một lần tìm (chung "tt_video"). Selector = các khối đã đo thật (tim_video, binh_luan, luot_video).
const TT_DK_TU_TIM = "len(trim(tk_video_tt)) > 0";
const TT_TIM_CHUNG = `  - id: tk_video_tt
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_video_tt

  - id: tim_video_tt_tu_tim
    when: "${TT_DK_TU_TIM}"
    on: web
    do: "tìm video TikTok theo từ khoá {{tk_video_tt}}"
    expect: "url chứa /search"

  - id: lay_nick_tt_tu_tim
    when: "${TT_DK_TU_TIM}"
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ)"
    into: nick_tt_tu_tim
    optional: true

  - id: lay_video_tt_tu_tim
    when: "${TT_DK_TU_TIM}"
    on: web
    extract: "danh sách video: tac_gia, mo_ta, lien_ket"
    into: ds_video_tt

  - id: loc_video_tt_tu_tim
    when: "${TT_DK_TU_TIM}"
    filter: "len(str(item.lien_ket)) > 0 and not (len(str(nick_tt_tu_tim)) > 0 and lower(str(item.tac_gia)) == lower(str(nick_tt_tu_tim)))"
    into: ds_video_tt`;
const TT_HOC_TIM_CHUNG = {
  tim_video_tt_tu_tim: { actions: [{ kind: "navigate", url: "{{goc}}search/video?q={{ts_url.tu_khoa_tu_tim}}&t=1" }] },
  lay_nick_tt_tu_tim: { extract_spec: TT_NICK_SPEC },
  lay_video_tt_tu_tim: { extract_spec: VIDEO_LIST_SPEC, ghi_khi_rong: "không tìm thấy video nào theo từ khoá — không có gì để làm" },
  loc_video_tt_tu_tim: { ly_do_bo: "video không có liên kết, hoặc là video của CHÍNH nick đang dùng" },
};
const TT_LY_DO_KHONG_VIDEO = (viec: string) => `Không tìm được video phù hợp để ${viec} lúc này (không có từ khoá/sản phẩm/mục tiêu để tìm, hoặc video tìm được đều của nick mình / đã ${viec} / không liên quan) — không ${viec} bừa`;
const TT_TU_TIM_BINH_LUAN = {
  thamSo: "bai_url", chung: "tt_video", yamlTim: TT_TIM_CHUNG,
  yamlSteps: `  - id: chon_video_bl_tt_tu_tim
    when: "${TT_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_binh_luan"
    into: ds_video_tt

  - id: soan_video_bl_tt_tu_tim
    for_each: ds_video_tt
    max_items: 1
    when: "${TT_DK_TU_TIM}"
    generate:
      input: "Video của {{item.tac_gia}}: {{item.mo_ta}} — viết bình luận cho video này với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 25
      anh: item.anh_url
    into: item.binh_luan

  - id: dang_video_bl_tt_tu_tim
    for_each: ds_video_tt
    max_items: 1
    when: "${TT_DK_TU_TIM} and len(ds_video_tt) > 0"
    ly_do_bo_qua: "${TT_LY_DO_KHONG_VIDEO("bình luận")}"
    on: web
    do: "mở video {{item.lien_ket}}, gõ {{item.binh_luan}} vào ô Add comment rồi Enter"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan`,
  learned: { ...TT_HOC_TIM_CHUNG, chon_video_bl_tt_tu_tim: { ly_do_bo: "nick đã bình luận video này ở lần chạy trước (sổ cái)" }, dang_video_bl_tt_tu_tim: { actions: DANG_ACTIONS, postcondition: DA_GUI("item.lien_ket", "{{item.binh_luan}}") } },
  params: { goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
  chamPhuHop: { danhSach: "ds_video_tt", truong: "mo_ta", truocBuoc: "soan_video_bl_tt_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const TT_TU_TIM_XEM = {
  thamSo: "bai_url", chung: "tt_video", yamlTim: TT_TIM_CHUNG,
  yamlSteps: `  - id: xem_video_tt_tu_tim
    for_each: ds_video_tt
    max_items: 1
    when: "${TT_DK_TU_TIM}"
    on_item_error: skip
    steps:
      - id: mo_video_xem_tt_tu_tim
        on: web
        do: "mở video {{item.lien_ket}} để xem"
        expect: "trang có video"
      - id: cho_xem_video_tt_tu_tim
        wait: {{ts.giay_xem}}`,
  learned: { ...TT_HOC_TIM_CHUNG, xem_video_tt_tu_tim: { con: { mo_video_xem_tt_tu_tim: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [TT_CO_VIDEO] } } } },
  chamPhuHop: { danhSach: "ds_video_tt", truong: "mo_ta", truocBuoc: "xem_video_tt_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const TT_TU_TIM_THICH = {
  thamSo: "bai_url", chung: "tt_video", yamlTim: TT_TIM_CHUNG,
  yamlSteps: `  - id: chon_video_thich_tt_tu_tim
    when: "${TT_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_thich_video"
    into: ds_video_tt

  - id: thich_video_tt_tu_tim
    for_each: ds_video_tt
    max_items: 1
    when: "${TT_DK_TU_TIM} and len(ds_video_tt) > 0"
    ly_do_bo_qua: "${TT_LY_DO_KHONG_VIDEO("thích")}"
    on: web
    do: "mở video {{item.lien_ket}}, bấm Thích (tim) nếu chưa thích"
    expect: "nút tim chuyển sang đã thích"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_thich_video`,
  learned: { ...TT_HOC_TIM_CHUNG, chon_video_thich_tt_tu_tim: { ly_do_bo: "nick đã thích video này ở lần chạy trước (sổ cái)" },
    thich_video_tt_tu_tim: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, TT_THICH], postcondition: TT_DA_THICH,
      bo_qua_khi: [{ khi: TT_DA_THICH[0]!, ghi: "video đã được thích từ trước — không bấm (bấm lần hai là bỏ thích)" }] } },
  chamPhuHop: { danhSach: "ds_video_tt", truong: "mo_ta", truocBuoc: "thich_video_tt_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const TT_MO_TA_DIA_CHI = "Không bắt buộc — để trống thì bot tự tìm video phù hợp theo từ khoá (của bước Tìm / sản phẩm / mục tiêu)";

export const KHOI_TIKTOK: KhoiMau[] = themChiBaiLienQuan([
  {
    ten: "tim_video",
    moTa: "Tìm video TikTok theo từ khoá rồi lấy danh sách (tac_gia, mo_ta, luot_xem, lien_ket) vào biến ds_video",
    thamSo: [{ ten: "tu_khoa", moTa: "từ khoá tìm video, tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true }],
    params: { tu_khoa: { type: "string", default: "{{ts.tu_khoa}}", label: "Từ khoá tìm video" } },
    yamlSteps: `  - id: tim_kiem
    on: web
    do: "tìm video theo từ khoá {{tu_khoa}}"
    expect: "url chứa /search"

  - id: lay_danh_sach
    on: web
    extract: "danh sách video: tac_gia, mo_ta, luot_xem, lien_ket"
    into: ds_video
    min_items: 1`,
    learned: {
      tim_kiem: { actions: [{ kind: "navigate", url: "{{goc}}search/video?q={{tu_khoa}}&t=1" }] }, // {{goc}} = trang gốc nền tảng, thay lúc lắp
      lay_danh_sach: { extract_spec: VIDEO_LIST_SPEC },
    },
  },
  {
    ten: "binh_luan",
    moTa: "Với danh sách ds_video đã có: bỏ video đã bình luận (sổ cái), AI soạn bình luận bám mô tả video theo knowledge, mở video và đăng (rủi ro cao, ghi sổ cái)",
    thamSo: [{ ten: "so_video", moTa: "số video tối đa sẽ bình luận trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 }],
    chamPhuHop: { danhSach: "ds_video", truong: "mo_ta", truocBuoc: "soan", maxItemsTu: "so_video", anh: "anh_url" },
    yamlSteps: `  - id: chon_video
    filter: "item.lien_ket not in ledger.da_binh_luan"

  - id: soan
    for_each: ds_video
    max_items: {{ts.so_video}}
    generate:
      input: "Video của {{item.tac_gia}}: {{item.mo_ta}}"
      guide: knowledge
      max_words: 25
      anh: item.anh_url
    into: item.binh_luan

  - id: dang_binh_luan
    for_each: ds_video
    max_items: {{ts.so_video}}
    on: web
    do: "mở video {{item.lien_ket}}, gõ {{item.binh_luan}} vào ô Add comment rồi Enter"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: DANG_ACTIONS, postcondition: DA_GUI("item.lien_ket", "{{item.binh_luan}}") } },
  },
  {
    ten: "tra_loi_binh_luan",
    moTa: "Mở MỘT video cho sẵn (tham số kịch bản video_url), đọc các bình luận cấp 1, bỏ bình luận của chính mình và đã trả lời (sổ cái), AI soạn câu trả lời theo knowledge rồi bấm Reply và gửi (rủi ro cao). Dùng độc lập với tim_video.",
    chamPhuHop: { danhSach: "ds_bl", truong: "noi_dung", truocBuoc: "soan_tra_loi", maxItemsTu: "so_tra_loi", anh: "anh_url" },
    thamSo: [
      { ten: "so_tra_loi", moTa: "số bình luận tối đa sẽ trả lời trong một lần chạy (1-3)", kieu: "so", batBuoc: true, min: 1, max: 3 },
      { ten: "video_url", moTa: "liên kết video TikTok cần chăm sóc bình luận (người dùng cho); để trống nếu chưa biết — người dùng sẽ điền lúc chạy", kieu: "chuoi", macDinh: "https://www.tiktok.com/" },
      { ten: "tai_khoan", moTa: "tên hiển thị tài khoản TikTok của mình, BẮT BUỘC để máy không trả lời chính mình; bỏ trống thì máy KHÔNG trả lời bình luận nào cả", kieu: "chuoi", macDinh: "" },
    ],
    params: {
      video_url: { type: "string", default: "{{ts.video_url}}", label: "Liên kết video cần trả lời bình luận" },
      tai_khoan: { type: "string", default: "{{ts.tai_khoan}}", label: "Tên hiển thị của mình trên TikTok — bỏ trống thì không trả lời bình luận nào" },
    },
    yamlSteps: `  - id: mo_binh_luan
    on: web
    do: "mở video {{video_url}} rồi mở bảng bình luận"
    expect: "url chứa /video/"

  - id: lay_binh_luan
    on: web
    extract: "bình luận cấp 1: nguoi, noi_dung, thich"
    into: ds_bl
    min_items: 1

  - id: loc_binh_luan
    filter: "len(tai_khoan) > 0 and item.nguoi != tai_khoan and item.noi_dung not in ledger.da_tra_loi"

  - id: soan_tra_loi
    for_each: ds_bl
    max_items: {{ts.so_tra_loi}}
    generate:
      input: "Bình luận của {{item.nguoi}} dưới video: {{item.noi_dung}} — (bạn là một NGƯỜI XEM KHÁC, KHÔNG phải chủ video/kênh: đáp lại như đang cùng xem, không cảm ơn hay hứa hẹn thay chủ kênh)"
      guide: knowledge
      max_words: 25
      anh: item.anh_url
    into: item.tra_loi

  - id: gui_tra_loi
    for_each: ds_bl
    max_items: {{ts.so_tra_loi}}
    on: web
    do: "bấm Reply của bình luận này, gõ {{item.tra_loi}} vào ô Add a reply rồi Enter"
    expect: "thấy chữ '{{item.tra_loi}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_tra_loi`,
    learned: {
      // Hậu kiểm: bảng bình luận thật sự mở (có ô nhập) — không chỉ url; nút Bình luận TikTok hay "bấm rơi vào khoảng không" lúc mới tải
      // → runner bấm lại một lần khi hậu kiểm chưa đạt.
      // url_contains {{video_url}}: trang video TikTok là feed dọc — hết video có thể TỰ CHUYỂN sang video kế (kiểm thật 2026-09-21: URL đổi
      // sang @kiensearchmarketing trong lúc đọc bình luận) → phải chốt đúng video ở bước mở và ở TỪNG lần gửi; lệch thì dừng mục, không gửi nhầm.
      mo_binh_luan: { actions: MO_BINH_LUAN_ACTIONS("{{video_url}}"), postcondition: [{ t: "url_contains", s: "{{video_url}}" }, { t: "dom_exists", sel: '[data-e2e="comment-text"]' }] },
      lay_binh_luan: { extract_spec: COMMENT_LIST_SPEC },
      gui_tra_loi: { actions: TRA_LOI_ACTIONS, postcondition: [...DA_GUI("video_url", "{{item.tra_loi}}"), DUOI_DUNG_CHA(KHOI_BL_MUC, "item.tra_loi")] },
    },
  },
  {
    ten: "tra_loi_mot_binh_luan",
    moTa: "Trả lời ĐÚNG một bình luận dưới video (tìm theo chữ): AI soạn câu như người xem khác. Rủi ro cao — có cổng duyệt, sửa được câu.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ video (https://www.tiktok.com/@<tên>/video/<số>)", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bình luận cần trả lời", kieu: "chuoi", batBuoc: true },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bình luận" } },
    yamlSteps: `  - id: soan_tra_loi
    generate:
      input: "Trả lời bình luận này như một người xem khác, không phải chủ video: {{chu_binh_luan}}"
      guide: knowledge
      max_words: 30
    into: cau_tra_loi

  - id: gui_tra_loi
    on: web
    do: "mở video {{bai_url}}, bấm Reply ở bình luận có chữ {{chu_binh_luan}}, gõ {{cau_tra_loi}} rồi Enter"
    expect: "thấy chữ '{{cau_tra_loi}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_tra_loi_bl`,
    learned: { gui_tra_loi: { actions: TT_TRA_LOI_MOT_ACTIONS, postcondition: [...DA_GUI("bai_url", "{{cau_tra_loi}}"), DUOI_DUNG_CHA(KHOI_BL_CHA("chu_binh_luan"), "cau_tra_loi")] } },
  },
  {
    ten: "binh_luan_mot_bai",
    moTa: "Bình luận vào MỘT video: có địa chỉ (bai_url) → đúng video đó (nhiều nick cùng vào một video, mỗi nick một góc nhìn); ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu), bỏ video của chính nick và video đã bình luận, có sản phẩm/mục tiêu thì AI chấm video liên quan; không có video hợp → không làm gì. Rủi ro cao — có cổng duyệt.",
    thamSo: [
      { ten: "bai_url", moTa: `địa chỉ video — ${TT_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
      { ten: "goc_nhin", moTa: "góc nhìn của nick này", kieu: "chuoi", batBuoc: false },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" }, goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
    yamlSteps: `  - id: soan
    generate:
      input: "Viết bình luận cho video này với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 30
    into: binh_luan

  - id: dang_binh_luan
    on: web
    do: "mở video {{bai_url}}, gõ {{binh_luan}} vào ô Add comment rồi Enter"
    expect: "thấy chữ '{{binh_luan}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: TT_BINH_LUAN_MOT_ACTIONS, postcondition: DA_GUI("bai_url", "{{binh_luan}}") } },
    tuTim: TT_TU_TIM_BINH_LUAN,
  },
  // ---------- như người (2026-10-01) ----------
  {
    ten: "xem_video",
    moTa: "Mở MỘT video và xem số giây cho sẵn, như người trước khi thích/bình luận. Có địa chỉ → đúng video đó; ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bỏ video của chính nick; có sản phẩm/mục tiêu thì AI chấm liên quan) — các bước Thích/Bình luận để trống phía sau làm đúng video vừa xem. Chỉ xem.",
    thamSo: [
      { ten: "bai_url", moTa: `địa chỉ video (https://www.tiktok.com/@<tên>/video/<số>) — ${TT_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
      TT_TS_GIAY_XEM,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" } },
    yamlSteps: `  - id: mo_video_xem
    on: web
    do: "mở video {{bai_url}} để xem"
    expect: "trang có video"

  - id: xem_video_tt
    wait: {{ts.giay_xem}}`,
    learned: { mo_video_xem: { actions: [{ kind: "navigate", url: "{{bai_url}}" }], postcondition: [TT_CO_VIDEO] } },
    tuTim: TT_TU_TIM_XEM,
  },
  {
    ten: "thich_video",
    moTa: "Thích (tim) MỘT video, chỉ khi chưa thích. Có địa chỉ → đúng video đó; ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bỏ video của chính nick, video đã thích; có sản phẩm/mục tiêu thì AI chấm liên quan) — đặt sau bước Xem để trống thì thích đúng video vừa xem. Rủi ro cao — có duyệt; sổ cái chống bấm lần hai.",
    thamSo: [{ ten: "bai_url", moTa: `địa chỉ video — ${TT_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false }],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" } },
    yamlSteps: `  - id: thich_video_tt
    on: web
    do: "mở video {{bai_url}}, bấm Thích (tim) nếu chưa thích"
    expect: "nút tim chuyển sang đã thích"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_thich_video`,
    learned: { thich_video_tt: { actions: [{ kind: "navigate", url: "{{bai_url}}" }, TT_THICH], postcondition: TT_DA_THICH } },
    tuTim: TT_TU_TIM_THICH,
  },
  {
    ten: "luot_video",
    moTa: "Với ds_video vừa tìm: mở từng video, xem số giây cho sẵn, thỉnh thoảng Thích (tỉ lệ nhỏ, có duyệt). Đặt bước Bình luận SAU bước này.",
    thamSo: [
      { ten: "so_video", moTa: "số video lướt xem tối đa (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      TT_TS_GIAY_XEM,
      TT_TS_TI_LE_THICH,
    ],
    params: { ti_le_thich: { type: "string", default: "{{ts.ti_le_thich}}", label: "Tỉ lệ % video được thích khi lướt (0-30)" } },
    yamlSteps: `  - id: luot_xem_video
    for_each: ds_video
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: mo_video_luot
        on: web
        do: "mở video {{item.lien_ket}} để xem"
        expect: "trang có video"
      - id: xem_video_luot
        wait: {{ts.giay_xem}}
      - id: thich_video_luot
        when: "${TT_DK_THICH_LUOT}"
        ly_do_bo_qua: "Lần này chưa tới lượt thích video nào (tỉ lệ thích {{ts.ti_le_thich}}%) — chỉ lướt xem"
        on: web
        do: "mở lại video {{item.lien_ket}}, bấm Thích (tim) nếu chưa thích"
        expect: "nút tim chuyển sang đã thích"
        risk: high
        idempotent: unsafe
        timeout: 45s
        ledger: da_thich_video`,
    learned: {
      // Bước con của vòng xem: phần đã học nằm dưới bước cha (con) — xem gopDaHoc trong shared/tu-dung.ts.
      luot_xem_video: { con: {
        mo_video_luot: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [TT_CO_VIDEO] },
        thich_video_luot: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, TT_THICH], postcondition: TT_DA_THICH },
      } },
    },
  },
  {
    ten: "luot_de_xuat",
    moTa: "Lướt trang Dành cho bạn: xem mỗi video số giây cho sẵn rồi sang video kế. Chỉ xem (rủi ro thấp) — giữ nick hoạt động tự nhiên.",
    thamSo: [
      { ten: "so_video", moTa: "số video lướt xem (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      TT_TS_GIAY_XEM,
    ],
    yamlSteps: `  - id: mo_de_xuat
    on: web
    do: "mở trang Dành cho bạn"
    expect: "có video đề xuất"

  - id: luot_de_xuat_vong
    for_each: "[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: xem_de_xuat
        wait: {{ts.giay_xem}}
      - id: sang_video_ke
        on: web
        do: "bấm sang video kế tiếp"`,
    learned: {
      mo_de_xuat: { actions: [{ kind: "navigate", url: "{{goc}}foryou" }], postcondition: [TT_CO_VIDEO] },
      luot_de_xuat_vong: { con: { sang_video_ke: { actions: [{ kind: "click", target: { describe: "nút sang video kế tiếp", ladder: [{ t: "css", sel: '[data-e2e="feed-navigation-next"]' }] } }] } } },
    },
  },
  {
    ten: "nghi",
    moTa: "Nghỉ một lúc như người thật, không làm gì trên trang — đặt GIỮA hai việc.",
    thamSo: [{ ten: "giay_nghi", moTa: "số giây nghỉ (5-1800)", kieu: "so", min: 5, max: 1800, macDinh: "60" }],
    yamlSteps: `  - id: nghi
    wait: {{ts.giay_nghi}}`,
    learned: {},
  },
  // ---------- 2026-10-03: trả lời bình luận dưới video của CHÍNH mình ----------
  {
    ten: "tra_loi_binh_luan_kenh_minh",
    moTa: "Trả lời bình luận dưới các video CỦA CHÍNH MÌNH (tư cách chủ kênh): máy tự đọc nick TikTok đang đăng nhập, mở trang cá nhân, lần lượt so_video video mới nhất (bỏ video ghim), mở bảng bình luận, chỉ trả lời bình luận của NGƯỜI KHÁC chưa được mình phản hồi (bỏ bình luận của chính mình, đã trả lời — sổ cái), AI soạn câu đáp như chủ kênh rồi bấm Reply và gửi (rủi ro cao, có duyệt). Tối đa so_cau câu mỗi lượt cho mọi video. Dùng độc lập, không cần tìm kiếm.",
    thamSo: [
      { ten: "so_video", moTa: "số video mới nhất của mình sẽ xem bình luận (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 },
      { ten: "so_cau", moTa: "số câu trả lời tối đa MỖI LƯỢT chạy, tính chung mọi video (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
    ],
    yamlSteps: `  - id: mo_trang_chu_tt_kenh
    on: web
    do: "mở TikTok để đọc nick đang dùng"
    expect: "trang TikTok"

  - id: lay_nick_tt
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ ở thanh bên)"
    into: nick_tt
    timeout: 15s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: mo_trang_ca_nhan_tt
    on: web
    do: "mở trang cá nhân @{{nick_tt}}"
    expect: "url chứa /@{{nick_tt}}"

  - id: lay_video_ca_nhan_tt
    on: web
    extract: "video trên trang cá nhân của mình: lien_ket, ghim, luot_xem"
    into: ds_video_tt
    timeout: 20s

  - id: chon_video_tt
    filter: "not item.ghim and len(str(item.lien_ket)) > 0"
    into: ds_video_tt

  - id: dem_cau_tt
    template: "x"
    into: dem_cau_tt

  - id: tra_loi_video_tt
    for_each: ds_video_tt
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: mo_bl_video_tt
        on: web
        do: "mở video {{item.lien_ket}} của mình rồi mở bảng bình luận"
        expect: "trang đúng video, bảng bình luận mở"
      - id: ghi_video_tt
        template: "{{item.lien_ket}}"
        into: video_tt_url
      - id: lay_bl_video_tt
        on: web
        extract: "bình luận cấp 1: nguoi, nguoi_id, noi_dung, kenh_tl_lien_ket, kenh_tl_nhan"
        into: item.ds_bl
        timeout: 15s
      - id: tra_loi_bl_tt
        for_each: item.ds_bl
        max_items: {{ts.so_cau}}
        when: "len(nick_tt) > 1 and len(dem_cau_tt) <= {{ts.so_cau}} and len(str(item.noi_dung)) > 0 and lower(str(item.nguoi_id)) != lower(nick_tt) and lower(str(item.nguoi)) != lower(nick_tt) and not item.kenh_tl_lien_ket and not item.kenh_tl_nhan and (video_tt_url + '/' + item.noi_dung) not in ledger.da_tra_loi_kenh_tt"
        on_item_error: skip
        steps:
          - id: soan_tra_loi_tt_kenh
            generate:
              input: "{{ str(item.nguoi) }} bình luận dưới video TikTok của bạn: {{item.noi_dung}} — (bạn là CHỦ KÊNH đăng video này: đáp lại người xem như chủ kênh — cảm ơn / giải đáp đúng điều họ nói, ngắn gọn, thân thiện; không hứa điều video không có, không chèn liên kết)"
              guide: knowledge
              max_words: 25
              anh: item.anh_url
            into: item.tra_loi
          - id: dem_cau_tt_them
            template: "{{dem_cau_tt}}x"
            into: dem_cau_tt
          - id: gui_tra_loi_tt_kenh
            on: web
            do: "bấm Reply của bình luận này, gõ {{item.tra_loi}} vào ô Add a reply rồi Enter"
            expect: "câu trả lời hiện dưới đúng bình luận cha"
            risk: high
            timeout: 60s
            on_item_error: skip
            ledger: da_tra_loi_kenh_tt`,
    learned: {
      mo_trang_chu_tt_kenh: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
      lay_nick_tt: { extract_spec: TT_NICK_SPEC },
      mo_trang_ca_nhan_tt: { actions: [{ kind: "navigate", url: "{{goc}}@{{nick_tt}}" }], postcondition: [{ t: "url_contains", s: "/@{{nick_tt}}" }] },
      // L-97/L-106: danh sách CỦA MÌNH rỗng = không có việc (lần chạy sạch, câu dễ hiểu), không phải "có thể chưa đăng nhập" (đã đọc được nick ở bước trước).
      lay_video_ca_nhan_tt: { extract_spec: TT_VIDEO_CA_NHAN_SPEC, khong_viec_khi_rong: "Trang cá nhân TikTok của bạn chưa có video nào — không có bình luận nào để trả lời" },
      tra_loi_video_tt: { con: {
        // Hậu kiểm mở: ĐÚNG video (mã video) + bảng bình luận mở (có ô nhập) — video 0 bình luận vẫn đạt (bước đọc ra 0 mục, 0 việc).
        mo_bl_video_tt: { actions: MO_BINH_LUAN_ACTIONS("{{item.lien_ket}}"), postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, { t: "dom_exists", sel: '[data-e2e="comment-text"]' }] },
        lay_bl_video_tt: { extract_spec: TT_BL_KENH_SPEC, khong_viec_khi_rong: "Các video của bạn chưa có bình luận nào — không có gì để trả lời lúc này" },
        tra_loi_bl_tt: { con: {
          gui_tra_loi_tt_kenh: { actions: TT_TRA_LOI_KENH_ACTIONS, postcondition: [...DA_GUI("video_tt_url", "{{item.tra_loi}}"), DUOI_DUNG_CHA(KHOI_BL_MUC, "item.tra_loi")] },
        } },
      } },
    },
  },
]);
